export default {
  form: {
    country: {
      label: 'Pays',
      placeholder: 'Sélectionner un pays',
    },
  },
};
